import dayjs from "@lib/dayjs";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { IMessageJobMembersProfile } from "@endpoints/types/message.type";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { EnumUserTypes } from "@utils/constants";

type JobMembersCardProps = {
  item: IMessageJobMembersProfile;
  selectedContact: any;
  setSelectedContact:any;
  userId:string
};

const JobMembersCard = (props: JobMembersCardProps) => {
  const navigate = useNavigate();
  const { item, selectedContact } = props;
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get("jobId");
  const routeParticipantId = searchParams.get("participantId");
  const [expandCard, setExpandCard] = useState(false);

  // const isReferral = user.userType === EnumUserTypes.REFERRAL_AMBASSADOR;

  // const latestJob = item.appliedJobs.reduce((latest, job) => {
  //   if (!job.lastMessageCreatedAt) return latest;

  //   return !latest ||
  //     dayjs(job.lastMessageCreatedAt).isAfter(
  //       dayjs(latest.lastMessageCreatedAt)
  //     )
  //     ? job
  //     : latest;
  // }, null);

  const handleItemClick = (room:any) => {
    props?.setSelectedContact(room)
    const params = new URLSearchParams({ jobId: room.jobId });
    const category = searchParams.get("conversationCategory");
    if (category) params.set("conversationCategory", category);
    const peer = room.participantDetails?.userId || room.participantDetails?._id;
    if (peer) params.set("participantId", peer);
    navigate(`/messages?${params.toString()}`);
  };

  const participantId = item?.participantDetails?.userId || item?.participantDetails?._id;
  const isSelected = !!participantId && participantId === (selectedContact?.participantDetails?.userId || selectedContact?.participantDetails?._id);
  const profilePic = useMemo(() => item?.participantDetails?.profilePic, [item?.participantDetails?.profilePic])
  const fullName = useMemo(() => item?.participantDetails?.name, [item?.participantDetails?.name])
  const companyName = useMemo(() => item?.participantDetails?.companyName, [item?.participantDetails?.companyName])
  const referenceId = useMemo(() => item?.participantDetails?.referenceId, [item?.participantDetails?.referenceId])

  // Card will expand and show the applied jobs on first load
  const hasSelectedRoom = (!routeParticipantId || routeParticipantId === participantId) &&
    item?.recentRooms?.some((room) => room.jobId === jobId);
  useEffect(() => {
    setExpandCard(!!hasSelectedRoom);
  }, [jobId, hasSelectedRoom]);

  return (
    <div className="flex flex-col border-b border-[#bababa]">
      <div
        className={`flex justify-between py-3 px-4 cursor-pointer hover:bg-gray-50 ${isSelected ? "bg-[#F1F5F9]" : ""
          }`}
        // key={item?.appliedJobs[0]?.lastMessage||index}
        onClick={() => setExpandCard((prev) => !prev)}
      >
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full self-start flex bg-[#E1E0E0] bg-nwhited shadow-sm">
            {profilePic ? (
              <img
                src={profilePic}
                className="h-full w-full object-cover rounded-full"
                alt="profileImg"
              />
            ) : (
              <div className="font-montserrat text-white font-semibold uppercase w-10 h-10 rounded-full bg-gray-400 flex items-center justify-center text-xl">
                {fullName?.charAt(0)}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-1 text-xs">
            <p className="text-charcoal font-bold">
              {fullName}
            </p>
            <p className="text-light-black font-medium">
              {companyName}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-end justify-between text-[11px]">
          <p className="text-light-black font-medium">
            {referenceId}
          </p>
          {item?.totalUnread > 0 && (
            <div className="text-[10px] font-medium bg-[#0C9D44] text-white rounded-full h-4 w-4 text-center">
              {item?.totalUnread}
            </div>
          )}
        </div>
      </div>
      {/* Applied jobs */}
      {expandCard ? (
        <div className="flex flex-col">
          {item?.recentRooms?.map((recentRoom, aIndex) => {
            const unreadCount = recentRoom?.unreadCounts?.[props?.userId] || 0
            return (
              <div
                key={recentRoom?.jobId}
                onClick={() => {
                  const updatedRoom = {
                    ...recentRoom,
                    participantDetails: item?.participantDetails
                  }
                  // handleContactSelect(recentRoom.jobId);
                  handleItemClick(updatedRoom);
                }}
                className={`py-2 hover:bg-gray-50 cursor-pointer  ${aIndex !== 0 ? "border-t" : ""
                  }`}
              >
                <div className={`flex flex-col border-l ml-8 px-3 py-1 gap-1`}>
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-xs text-charcoal">
                      {recentRoom?.jobTitle}
                    </span>
                    {unreadCount > 0 ? (
                      <div className="text-[10px] font-medium bg-[#BABABA] text-white rounded-full h-4 w-4 text-center">
                        {unreadCount}
                      </div>
                    ) : null}
                  </div>
                  <span className="font-medium text-light-black text-xs">
                    {recentRoom?.lastMessage?.content}
                  </span>
                  <span className=" text-gray-400 text-xs italic">
                    {dayjs(recentRoom?.lastActivityAt).format(
                      "hh:mm a, DD/MM/YYYY"
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default JobMembersCard;
